import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/summary/admin/adminSummaryQueryKeys.ts
var t = e("admin-summary", { counts: () => ["counts"] });
//#endregion
export { t as adminSummaryQueryKeys };
